import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FinancialYearStatus, FinancialYearStatusTranslations } from 'src/app/core/enums/financial-year-status.enum';

@Pipe({
    name: 'financialYearStatus',
    pure: false
})
export class FinancialYearStatusPipe implements PipeTransform {
    constructor(private translateService: TranslateService) { }

    transform(value: string | undefined): string {
        if (!value) {
            return '-';
        }
        
        const translationKey = FinancialYearStatusTranslations[value] || `FINANCIALYEAR.STATUS.${value.toUpperCase()}`;
        const translatedValue = this.translateService.instant(translationKey);

        // Fallback to original value if translation not found
        return translatedValue === translationKey ? value : translatedValue;
    }
}
